import { EditComponent } from '../../app-lite/table/cell-components/actions/edit.component';

export function ProductHistoryCtrl (
  $scope,
  $state,
  $translate,
  tableApi,
  workshopAPI
) {
  $scope.showProductVendorInvoices = !!$scope.vendorInvoices.length;
  $scope.tableCacheKey             = 'productHistory';

  $scope.tableSettings = {
    cache: {
      enabled: true,
      key    : $scope.tableCacheKey
    },
    columns: [
      {
        field : 'vendor_invoice_number',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.REFERENCE')
        },
      },
      {
        field : 'post_date',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.POST_DATE')
        },
        pipe: 'globalDate'
      },
      {
        field : 'company_name',
        header: {
          text: $translate.instant('VENDOR_SPACE.SUPPLIER')
        }
      },
      {
        classes: 'text-right',
        field  : 'quantity',
        header : {
          classes: 'text-right',
          text   : $translate.instant('JS_SPACE.COLUMNS.QUANTITY')
        },
        pipe: 'number'
      },
      {
        classes: 'text-right',
        field  : 'total',
        header : {
          classes: 'text-right',
          text   : $translate.instant('JS_SPACE.COLUMNS.AMOUNT')
        },
        pipe: 'globalCurrency'
      },
      {
        classes: 'text-right',
        field  : 'invoice_status',
        header : {
          classes: 'text-right',
          text   : $translate.instant('GENERAL_SPACE.FIELD.STATUS')
        },
        pipe: 'invoiceStatus'
      },
      {
        component: {
          bindings: {
            outputs: {
              onEditClick: event => $scope.viewInvoice(event)
            }
          },
          enabled: true,
          factory: EditComponent
        },
        sortable: false
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_PURCHASES_FOUND')
    },
    pagination: {
      enabled   : true,
      pageSize  : tableApi.getCachedPaging($scope.tableCacheKey).pageSize || 5,
      pageSizes : [ 5, 10, 25, 50 ],
      queryCount: () => workshopAPI.get('/products/vendor_invoice_count', $scope.product.id)
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: tableApi.setSortingFromCache($scope.tableCacheKey, {
      direction: 'asc',
      field    : 'post_date'
    })
  };

  $scope.getVendorInvoices = ( params ) => {
    return workshopAPI.get('/products/vendor_invoice_list', [
      $scope.product.id,
      params.offset,
      params.pageSize,
      params.field,
      params.direction,
    ]).then(vendorInvoices => {
      $scope.vendorInvoices = vendorInvoices;

      return vendorInvoices;
    });
  };

  $scope.onRowDoubleClick = function (event) {
    $scope.viewInvoice(event.row);
  };

  $scope.viewInvoice = function (invoice) {
    $state.go('app.vendor-invoice', {
      id       : invoice.id,
      vendor_id: invoice.vendor_id
    });
  };
};